
import clsBaseGlobal from './base'
const arrFillable = [
    "use_ledgers",
    "use_bookdate",
];


class clsGlobalPurchaseInvoice extends clsBaseGlobal {

    // From company settings edit
    use_ledgers         = false;
    use_ledgers         = false;

    get fillable() { return arrFillable; }

    fill(data) {
        data = data ||{};
        data.use_ledgers  = !!data.use_ledgers;
        data.use_bookdate = !!data.use_bookdate;
        return super.fill(data);
    }
}

export default clsGlobalPurchaseInvoice;